<template>
  <div
    class="bg-[var(--fundoForm)] w-full p-2 rounded-md flex flex-col gap-2 text-[var(--text)] items-center"
  >
    <form
      @submit.prevent="uploadDocument"
      class="flex flex-col gap-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48] p-2"
    >
      <div class="flex justify-between items-center">
        <h1 style="color:var(--titulo)">Documentos Utilizador</h1>
        <AppButton
        style="color: var(--icon);"
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="20"
          :height="20"
        />
      </div>

      <FormSelect
        v-model="tipo"
        id="tipo"
        label="Tipo:"
        :options="tipos"
        placeholder="Seleciona o Tipo de Documento"
        required
        class="rounded-md p-1"
        
      />

      <FormInput
        v-model="nome"
        id="nome"
        label="Nome:"
        placeholder="Nome do Documento"
        required
        class="rounded-md p-1"
      />

      <div class="grid grid-cols-2 items-center gap-1">
        <label for="documento" class="text-[var(--text)]">Documento:</label>
        <input
          type="file"
          @change="handleFileUpload"
          required
          class="rounded-md p-1"
        />
      </div>

      <div class="flex justify-end gap-2 mt-2">
        <button
          v-if="validPermission('C0047')"
          @click.prevent="toggleDocumentList"
          class="px-4 py-1 bg-sky-600 rounded-lg shadow-lg hover:bg-sky-700 text-white"
        >
          Ver Documentos
        </button>
        <button
          v-if="validPermission('C0012')"
          type="submit"
          class="px-4 py-1 bg-sky-600 rounded-lg shadow-lg hover:bg-sky-700 text-white"
        >
          Upload
        </button>
      </div>
    </form>

    <!-- Lista de Documentos -->
    <div
      v-if="showDocumentList"
      class="mt-4 p-2 rounded-md bg-[#545484] overflow-y-auto"
    >
      <div v-if="documentos.length > 0">
        <AppTable
          :visibility="true"
          :show="true"
          :table_data="documentos"
          table_title="Documentos Salvos"
          @row-clicked="select_documento"
          @close="toggleDocumentList"
          :show_multiSelect="false"
        />
      </div>
      <div v-else class="text-center text-[var(--text)] no-documents-message">
        Nenhum documento encontrado.
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppButton from "@/components/button.vue";
import AppTable from "@/components/tables/table.vue";
import FormInput from "@/components/FormInput.vue";
import FormSelect from "@/components/FormSelect.vue";
import { toast } from "vue3-toastify";
export default {
  name: "documentos",
  components: {
    AppButton,
    AppTable,
    FormInput,
    FormSelect,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      tipos: [],
      tipo: "",
      nome: "",
      documento: null,
      documentos: [],
      showDocumentList: false, // Controle de visibilidade
    };
  },
  async created() {
    await this.fetchTipos();
    // Inicialize a lista de documentos se necessário
  },
  methods: {
    close() {
      this.$emit("close"); // Emite o evento de fechamento
    },
    async fetchTipos() {
      try {
        const res = await axios.get(`${this.baseURL}/api/v1/tpdocumento/`);
        this.tipos = res.data.data;
      } catch (error) {
        console.error("Error fetching tipos:", error);
      }
    },
    async fetchDocumentos() {
      try {
        const res = await axios.get(
          `${this.baseURL}/api/v1/documentoutilizador/`
        );
        this.documentos = res.data.data.map((doc) => {
          const tipo = this.tipos.find(
            (tipo) => tipo.id === doc.tpDocumento_id
          ); 
          return {
            id: doc.id,
            tipoNome: tipo ? tipo.nome : "Tipo desconhecido",
            utilizador: doc.utilizador,
            nome: doc.nome,
            status: doc.status,
          };
        });
      } catch (error) {
        console.error("Error fetching documentos:", error);
      }
    },
    handleFileUpload(event) {
      this.documento = event.target.files[0];
    },
    async uploadDocument() {
      if (!this.validateForm()) {
        return; // Se a validação falhar, não prossegue com o upload
      }
      
      const formData = new FormData();
      formData.append("tpDocumento_id", this.tipo);
      formData.append("nome", this.nome);
      formData.append("documento", this.documento);

      try {
        const res = await axios.post(
          `${this.baseURL}/api/v1/documentoutilizador/registrar/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status == 200 || res.data.status == 201) {
          console.log("Documento enviado com sucesso:", res.data);
          this.resetForm();
          this.showDocumentList = true; // Exibe a lista de documentos após o upload
          await this.fetchDocumentos(); // Atualiza a lista de documentos
        } else {
          console.error("Erro ao enviar documento");
        }
      } catch (error) {
        console.error("Error uploading document:", error);
      }
    },
    resetForm() {
      this.documento = null;
      this.nome = "";
      this.tipo = "";
      
    },
    toggleDocumentList() {
      this.showDocumentList = !this.showDocumentList;
      if (this.showDocumentList) {
        this.fetchDocumentos();
      }
    },
    select_documento(documento) {},
    validPermission(permission) {
      return true;
    },

    validateForm() {
      if (!this.tipo) {
       
        toast("Tipo de documento é obrigatório.", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return false;
      }
      if (!this.nome) {
        
        toast("Nome do documento é obrigatório.", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return false;
      }
      if (!this.documento) {
      
        toast("Documento é obrigatório.", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return false;
      }
      return true;
    },

    isEmptyField(field) {
      if (["tipo", "nome"].includes(field)) {
        return (
          this[field] === null ||
          this[field] === undefined ||
          this[field].trim() === ""
        );
      }

      return false;
    },
  },
};
</script>

<style scoped>
.close-button-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 4px solid #ffffff;
  background-color: transparent;
  cursor: pointer;
}

.close-button-circle i {
  color: #ffffff;
  font-size: 12px;
}

.red-border {
  /* border: 1px solid red; */
  background-color: rgba(176, 88, 88, 0.664);
}
</style>
